/* High Quality — motor de animación de las secciones custom-*.

   Un solo `IntersectionObserver` para toda la página: los elementos con
   [data-chq-reveal] entran cuando asoman por el borde inferior. El TIPO de entrada lo
   elige `data-chq-anim` (subir, acercarse, entrar de lado, descubrirse); el retardo,
   `data-chq-delay`. Todo lo demás lo hace CSS.

   ── Por qué NO hay librerías aquí ──
   Esto cargaba GSAP + ScrollTrigger + Lenis: tres CDN distintos (~120 KB) para hacer un
   fundido. Se quitaron el 4 ago 2026 en la pasada de rendimiento porque cada CDN es una
   conexión nueva (DNS + TLS + descarga) antes de que nada se revele, y porque Lenis
   mantenía un bucle de animación corriendo TODO el rato — en móvil ni se aplicaba, así
   que se pagaba el bucle entero sin recibir nada.

   `IntersectionObserver` no consume nada mientras no pasa nada: el navegador avisa. Las
   transiciones son CSS sobre `transform` y `opacity`, las dos únicas propiedades que el
   navegador puede componer en la GPU sin recalcular la página.

   ── Las tres reglas que no se rompen ──
   1. **Solo `transform` y `opacity`.** Animar `height`, `top` o `margin` obliga al
      navegador a recalcular la maqueta en cada fotograma. Lo que necesite otra cosa
      (el desplegable del acordeón) lo hace el navegador por su cuenta, no este motor.
   2. **`will-change` se pone y se quita.** Regla del proyecto desde el 4 ago: dejarlo
      fijo mantiene una capa de GPU reservada para siempre por cada elemento. Aquí se
      añade justo antes de animar y se retira al terminar.
   3. **Fail-open.** Si algo falla —sin soporte, un elemento que nunca cruza el umbral,
      un error— el contenido se muestra igual. Vale más verlo sin animación que no
      verlo. Hay además una red de seguridad a los 4 s.

   Respeta `prefers-reduced-motion`: con el movimiento reducido no se anima nada. */
(function () {
  'use strict';

  var PENDIENTE = 'chq-pre-reveal';

  function revelarTodo() {
    var pendientes = document.querySelectorAll('.' + PENDIENTE);
    for (var i = 0; i < pendientes.length; i++) {
      pendientes[i].classList.remove(PENDIENTE);
      pendientes[i].style.willChange = '';
    }
  }

  /* Sin soporte o con movimiento reducido: se muestra todo y no se anima nada. */
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revelarTodo();
    return;
  }

  /* ── Contadores ───────────────────────────────────────────────────────────────
     Las cifras de prueba social (3136 ventas, 95 %…) suben desde cero al entrar. Se
     escribe en `textContent`, que no recalcula la maqueta si el hueco ya está
     reservado — por eso el CSS les fija `font-variant-numeric: tabular-nums`: sin
     ancho fijo por dígito, el número saltaría a cada fotograma. */
  function contar(el) {
    var destino = parseFloat(el.getAttribute('data-chq-count'));
    if (isNaN(destino)) return;
    var duracion = parseInt(el.getAttribute('data-chq-count-ms') || '1100', 10);
    var sufijo = el.getAttribute('data-chq-count-suf') || '';
    var decimales = (String(destino).split('.')[1] || '').length;
    var inicio = null;

    function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var t = Math.min((ahora - inicio) / duracion, 1);
      /* easeOutCubic: arranca rápido y frena al final — se lee como que "aterriza"
         en la cifra en vez de pararse en seco. */
      var suave = 1 - Math.pow(1 - t, 3);
      el.textContent = (destino * suave).toFixed(decimales) + sufijo;
      if (t < 1) requestAnimationFrame(paso);
      else el.textContent = destino.toFixed(decimales) + sufijo;
    }
    requestAnimationFrame(paso);
  }

  function armar() {
    var objetivos = document.querySelectorAll('[data-chq-reveal].' + PENDIENTE);
    var contadores = document.querySelectorAll('[data-chq-count]:not([data-chq-contado])');
    if (!objetivos.length && !contadores.length) return;

    var vigia = new IntersectionObserver(function (entradas) {
      for (var i = 0; i < entradas.length; i++) {
        var e = entradas[i];
        if (!e.isIntersecting) continue;
        var el = e.target;
        vigia.unobserve(el); /* una vez y se olvida: sin esto seguiría reportándolo */

        if (el.hasAttribute('data-chq-count')) {
          el.setAttribute('data-chq-contado', '1');
          contar(el);
        }

        if (!el.classList.contains(PENDIENTE)) continue;

        var retardo = parseFloat(el.getAttribute('data-chq-delay') || '0');
        if (retardo > 0) el.style.transitionDelay = retardo + 's';

        /* Se reserva la capa de GPU justo para esta transición y se suelta al
           acabar — nunca queda puesta (regla 2). */
        el.style.willChange = 'transform, opacity';
        el.classList.remove(PENDIENTE);

        (function (nodo) {
          var limpiar = function () {
            nodo.style.willChange = '';
            nodo.style.transitionDelay = '';
            nodo.removeEventListener('transitionend', limpiar);
          };
          nodo.addEventListener('transitionend', limpiar);
          /* Por si `transitionend` no llega (el elemento se oculta a mitad, o la
             transición se interrumpe): se limpia igual. */
          window.setTimeout(limpiar, (retardo + 1.4) * 1000);
        })(el);
      }
    }, {
      /* Se revela cuando le falta un 10 % de pantalla para entrar, no cuando ya
         está dentro: así el movimiento se ve, en vez de ocurrir fuera de cuadro. */
      rootMargin: '0px 0px -10% 0px',
      threshold: 0
    });

    for (var j = 0; j < objetivos.length; j++) vigia.observe(objetivos[j]);
    for (var k = 0; k < contadores.length; k++) vigia.observe(contadores[k]);

    window.setTimeout(revelarTodo, 4000); /* red de seguridad */
  }

  /* Hay que esperar a que la página esté leída ENTERA antes de buscar elementos.

     Este archivo lo inserta cada sección con `document.createElement('script')`, y un
     script insertado así **ignora `defer`**: se descarga y se ejecuta en cuanto llega,
     que puede ser mientras el navegador todavía está leyendo el resto de la página. Si
     `armar()` corre en ese momento, solo ve las secciones ya procesadas y las de más
     abajo se quedan sin observador.

     Pasó de verdad: los dos contadores del bloque de compra (arriba del todo) subían y
     el de las ventas (más abajo) se quedaba clavado en 0. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armar);
  } else {
    armar();
  }
  /* El editor de temas recarga secciones sueltas: hay que enganchar las nuevas. */
  document.addEventListener('shopify:section:load', armar);
})();
